
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 600 300"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#169b62","d":"M0 0h200v300H0z"}}),_c('path',{attrs:{"fill":"#fff","d":"M200 0h200v300H200z"}}),_c('path',{attrs:{"fill":"#ff883e","d":"M400 0h200v300H400z"}})])
          )
        }
      }
    